import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Envoltorio de las pantallas auth secundarias (olvidé contraseña, verificar código,
 * reset, verificación de correo) dentro de la zona de formularios del AuthCard:
 * padding, scroll interno y animación de entrada (estas rutas sí remontan por path).
 */
function AuthScreen({ children }) {
  return (
    <Box
      sx={{
        p: { xs: 2.5, md: 4 },
        overflowY: 'auto',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'safe center',
        '@keyframes authScreenIn': {
          from: { opacity: 0, transform: 'translateY(16px)' },
          to: { opacity: 1, transform: 'none' }
        },
        animation: 'authScreenIn 240ms cubic-bezier(0.32, 0.72, 0, 1)',
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' }
      }}>
      {children}
    </Box>
  );
}

AuthScreen.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthScreen;
